// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
(($: JQueryStatic) => {
    $.extend($, {
        el: (tagName: string, attributes: object) => {
            const $el = $(document.createElement(tagName));
            if(attributes) {
                $el.attr(attributes);
            }
            return $el;
        }
    });

    $.extend($.fn, {
        filterByData: function (prop: string, val: string): JQuery<HTMLElement> {
            const $self = $(this) as JQuery<HTMLElement>;
            if (typeof val === "undefined") {
                return $self.filter(
                    function (): boolean {
                        return typeof $(this).data(prop) !== "undefined";
                    }
                );
            }

            return $self.filter(
                function (): boolean {
                    return $(this).data(prop) === val;
                }
            );
        }
    });
})(jQuery);
